import { useItemSet } from '@exam-management/common/item-set-provider';
import { useQContent } from '@exam-management/common/qcontent-provider';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { useHasPermission } from '@shared/permissions';

import { DetailSectionWrapper } from '../../components';
import {
  EDITABLE_ITEM_QUESTION_B_INDEX_STATUSES,
  EDITABLE_ITEM_QUESTION_P_STAT_STATUSES,
  EDITABLE_ITEM_SET_QUESTION_DETAILS_STATUSES,
} from '../../constants';
import { DetailSection } from '../detail-section';
import { ItemSetSubQuestionInformationSection } from '../item-set-sub-question-information-section';
import { OwnerSection } from '../owner-section';
import { PropertiesSection } from '../properties-section';

export interface ItemSetSubQuestionDetailsProps {
  onClickUpdatePStat?: () => void;
  informationTitleEndAdornment?: JSX.Element;
}

export default function ItemSetSubQuestionDetails(props: Readonly<ItemSetSubQuestionDetailsProps>) {
  const { onClickUpdatePStat, informationTitleEndAdornment } = props;
  const { itemSet } = useItemSet();

  const {
    qContent: { id: subQuestionId, status: questionStatus },
  } = useQContent();

  const hasUpdatePermission = useHasPermission(APP_PERMISSIONS.QBANK.QUESTION.UPDATE);

  const isEditableByStatus = EDITABLE_ITEM_SET_QUESTION_DETAILS_STATUSES.includes(itemSet.status);
  const isEditable = isEditableByStatus && hasUpdatePermission;

  const shouldDisplayPStat = EDITABLE_ITEM_QUESTION_P_STAT_STATUSES.includes(questionStatus);
  const shouldDisplayBIndex = EDITABLE_ITEM_QUESTION_B_INDEX_STATUSES.includes(questionStatus);

  const mode = shouldDisplayPStat && shouldDisplayBIndex ? 'qcontent' : 'workflow';

  return (
    <DetailSectionWrapper>
      <ItemSetSubQuestionInformationSection
        questionStatus={questionStatus}
        readonly={!isEditable}
        onClickPStats={onClickUpdatePStat}
        mode={mode}
        titleEndAdornment={informationTitleEndAdornment}
      />
      <DetailSection
        questionId={subQuestionId}
        questionStatus={questionStatus}
        readonly={!isEditable}
      />
      <PropertiesSection
        questionId={subQuestionId}
        questionStatus={questionStatus}
        readonly={!isEditable}
      />
      <OwnerSection questionStatus={questionStatus} readonly={!isEditable} />
    </DetailSectionWrapper>
  );
}
